/* tslint:disable */
/* eslint-disable */
/**
 * NORA Api
 *  ## Headers  ### X-App-Version  Remember to include the `X-App-Version` header in every request. This will verify that the app version works with this API version. The API will return a `X-Minimum-App-Version` header as well including the minimum app version that is supported by this API. The contents of the header are is a JSON encoded DTO, `VersionHeaderDTO`. 
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ApiResult } from '../models';
// @ts-ignore
import type { GetChangelog200Response } from '../models';
// @ts-ignore
import type { GetFrontendSettingsV2200Response } from '../models';
// @ts-ignore
import type { GetPublicSettings200Response } from '../models';
// @ts-ignore
import type { GetUserSettings200Response } from '../models';
// @ts-ignore
import type { MapDisplaySettingsDTO } from '../models';
// @ts-ignore
import type { UpdateSettingDTO } from '../models';
// @ts-ignore
import type { UpdateUserSetting200Response } from '../models';
/**
 * SettingsApi - axios parameter creator
 */
export const SettingsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get the changelog for NORA
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChangelog: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/nora/settings/changelog`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary getFrontendSettingsV2
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFrontendSettingsV2: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/nora/settings/v2`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary getPublicSettings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPublicSettings: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/nora/settings/public`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary getUserSettings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserSettings: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/nora/settings/user`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary updateGlobalSetting
         * @param {UpdateSettingDTO} updateSettingDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateGlobalSetting: async (updateSettingDTO: UpdateSettingDTO, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateSettingDTO' is not null or undefined
            assertParamExists('updateGlobalSetting', 'updateSettingDTO', updateSettingDTO)
            const localVarPath = `/api/nora/settings/global`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateSettingDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * The map display settings represent the information shown on the bottom right of the map, such as the scale line and the toggled coordinate formats.
         * @summary Update the default map display settings for the user
         * @param {MapDisplaySettingsDTO} mapDisplaySettingsDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMapDisplaySettings: async (mapDisplaySettingsDTO: MapDisplaySettingsDTO, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'mapDisplaySettingsDTO' is not null or undefined
            assertParamExists('updateMapDisplaySettings', 'mapDisplaySettingsDTO', mapDisplaySettingsDTO)
            const localVarPath = `/api/nora/settings/user/map-display-settings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(mapDisplaySettingsDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * A generic endpoint that enables upsert of various user settings.
         * @summary Update the user\'s settings
         * @param {UpdateSettingDTO} updateSettingDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserSetting: async (updateSettingDTO: UpdateSettingDTO, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateSettingDTO' is not null or undefined
            assertParamExists('updateUserSetting', 'updateSettingDTO', updateSettingDTO)
            const localVarPath = `/api/nora/settings/user`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateSettingDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SettingsApi - functional programming interface
 */
export const SettingsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SettingsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get the changelog for NORA
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getChangelog(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetChangelog200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getChangelog(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingsApi.getChangelog']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary getFrontendSettingsV2
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFrontendSettingsV2(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetFrontendSettingsV2200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFrontendSettingsV2(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingsApi.getFrontendSettingsV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary getPublicSettings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPublicSettings(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetPublicSettings200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPublicSettings(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingsApi.getPublicSettings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary getUserSettings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserSettings(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetUserSettings200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserSettings(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingsApi.getUserSettings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary updateGlobalSetting
         * @param {UpdateSettingDTO} updateSettingDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateGlobalSetting(updateSettingDTO: UpdateSettingDTO, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateUserSetting200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateGlobalSetting(updateSettingDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingsApi.updateGlobalSetting']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * The map display settings represent the information shown on the bottom right of the map, such as the scale line and the toggled coordinate formats.
         * @summary Update the default map display settings for the user
         * @param {MapDisplaySettingsDTO} mapDisplaySettingsDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateMapDisplaySettings(mapDisplaySettingsDTO: MapDisplaySettingsDTO, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateMapDisplaySettings(mapDisplaySettingsDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingsApi.updateMapDisplaySettings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * A generic endpoint that enables upsert of various user settings.
         * @summary Update the user\'s settings
         * @param {UpdateSettingDTO} updateSettingDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateUserSetting(updateSettingDTO: UpdateSettingDTO, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateUserSetting200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateUserSetting(updateSettingDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingsApi.updateUserSetting']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SettingsApi - factory interface
 */
export const SettingsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SettingsApiFp(configuration)
    return {
        /**
         * 
         * @summary Get the changelog for NORA
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChangelog(options?: RawAxiosRequestConfig): AxiosPromise<GetChangelog200Response> {
            return localVarFp.getChangelog(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary getFrontendSettingsV2
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFrontendSettingsV2(options?: RawAxiosRequestConfig): AxiosPromise<GetFrontendSettingsV2200Response> {
            return localVarFp.getFrontendSettingsV2(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary getPublicSettings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPublicSettings(options?: RawAxiosRequestConfig): AxiosPromise<GetPublicSettings200Response> {
            return localVarFp.getPublicSettings(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary getUserSettings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserSettings(options?: RawAxiosRequestConfig): AxiosPromise<GetUserSettings200Response> {
            return localVarFp.getUserSettings(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary updateGlobalSetting
         * @param {SettingsApiUpdateGlobalSettingRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateGlobalSetting(requestParameters: SettingsApiUpdateGlobalSettingRequest, options?: RawAxiosRequestConfig): AxiosPromise<UpdateUserSetting200Response> {
            return localVarFp.updateGlobalSetting(requestParameters.updateSettingDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * The map display settings represent the information shown on the bottom right of the map, such as the scale line and the toggled coordinate formats.
         * @summary Update the default map display settings for the user
         * @param {SettingsApiUpdateMapDisplaySettingsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMapDisplaySettings(requestParameters: SettingsApiUpdateMapDisplaySettingsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiResult> {
            return localVarFp.updateMapDisplaySettings(requestParameters.mapDisplaySettingsDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * A generic endpoint that enables upsert of various user settings.
         * @summary Update the user\'s settings
         * @param {SettingsApiUpdateUserSettingRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserSetting(requestParameters: SettingsApiUpdateUserSettingRequest, options?: RawAxiosRequestConfig): AxiosPromise<UpdateUserSetting200Response> {
            return localVarFp.updateUserSetting(requestParameters.updateSettingDTO, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for updateGlobalSetting operation in SettingsApi.
 */
export interface SettingsApiUpdateGlobalSettingRequest {
    readonly updateSettingDTO: UpdateSettingDTO
}

/**
 * Request parameters for updateMapDisplaySettings operation in SettingsApi.
 */
export interface SettingsApiUpdateMapDisplaySettingsRequest {
    readonly mapDisplaySettingsDTO: MapDisplaySettingsDTO
}

/**
 * Request parameters for updateUserSetting operation in SettingsApi.
 */
export interface SettingsApiUpdateUserSettingRequest {
    readonly updateSettingDTO: UpdateSettingDTO
}

/**
 * SettingsApi - object-oriented interface
 */
export class SettingsApi extends BaseAPI {
    /**
     * 
     * @summary Get the changelog for NORA
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getChangelog(options?: RawAxiosRequestConfig) {
        return SettingsApiFp(this.configuration).getChangelog(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary getFrontendSettingsV2
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getFrontendSettingsV2(options?: RawAxiosRequestConfig) {
        return SettingsApiFp(this.configuration).getFrontendSettingsV2(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary getPublicSettings
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getPublicSettings(options?: RawAxiosRequestConfig) {
        return SettingsApiFp(this.configuration).getPublicSettings(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary getUserSettings
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getUserSettings(options?: RawAxiosRequestConfig) {
        return SettingsApiFp(this.configuration).getUserSettings(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary updateGlobalSetting
     * @param {SettingsApiUpdateGlobalSettingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateGlobalSetting(requestParameters: SettingsApiUpdateGlobalSettingRequest, options?: RawAxiosRequestConfig) {
        return SettingsApiFp(this.configuration).updateGlobalSetting(requestParameters.updateSettingDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * The map display settings represent the information shown on the bottom right of the map, such as the scale line and the toggled coordinate formats.
     * @summary Update the default map display settings for the user
     * @param {SettingsApiUpdateMapDisplaySettingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateMapDisplaySettings(requestParameters: SettingsApiUpdateMapDisplaySettingsRequest, options?: RawAxiosRequestConfig) {
        return SettingsApiFp(this.configuration).updateMapDisplaySettings(requestParameters.mapDisplaySettingsDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * A generic endpoint that enables upsert of various user settings.
     * @summary Update the user\'s settings
     * @param {SettingsApiUpdateUserSettingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateUserSetting(requestParameters: SettingsApiUpdateUserSettingRequest, options?: RawAxiosRequestConfig) {
        return SettingsApiFp(this.configuration).updateUserSetting(requestParameters.updateSettingDTO, options).then((request) => request(this.axios, this.basePath));
    }
}

